"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    nav: {
      backgroundColor: 'transparent',
      color: palette.text.primary
    },
    ul: {
      listStyleType: 'none',
      margin: 0,
      padding: 0
    },
    dropdownList: function dropdownList(_ref2) {
      var columnCount = _ref2.columnCount;
      return {
        listStyleType: 'none',
        margin: 0,
        columnCount: columnCount
      };
    },
    a: {
      textDecoration: 'none',
      color: palette.text.primary
    },
    overlay: function overlay(_ref3) {
      var height = _ref3.height,
          isOpen = _ref3.isOpen;
      return {
        height: height,
        left: 0,
        width: '100%',
        top: 0,
        transition: 'all 1250ms',
        opacity: isOpen ? 0.95 : 0
      };
    },
    li: {
      width: 'max-content'
    }
  };
});
var _default = useStyles;
exports["default"] = _default;